export default __webpack_public_path__ + "img/phone_icon1.png";